import View from 'govbr.frontend.policy/components/Blocks/Video/View';

export default View;
